import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import {
    isOcpsPolicyEnabled,
    isUserAllowedToChangeSettings,
    OcpsPolicyFeature,
    ReplyBehaviorPolicySettingId,
} from 'owa-owsprime-policies-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const APP_DEFAULT_REPLY_ALL = true;

export default function isReplyAllTheDefaultResponse(): boolean {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    const policyValue = isOcpsPolicyEnabled(
        ReplyBehaviorPolicySettingId.DefaultReadingPaneReplyBehaviorOptions,
        mailboxInfo,
        APP_DEFAULT_REPLY_ALL
    );
    if (!isUserAllowedToChangeSettings(OcpsPolicyFeature.ReplyBehavior, mailboxInfo)) {
        return policyValue;
    }

    return getUserConfiguration().UserOptions?.IsReplyAllTheDefaultResponse ?? policyValue;
}
